import Modal from 'react-modal';
import { useState, useEffect} from 'react';
import api from '../../../config.js';
import './kardex.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import { FaArrowLeft, FaArrowRight, FaCog, FaUser } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";
import moment from 'moment';
import 'moment-timezone';
import { format } from 'date-fns';
import ProductsInput from '../../../components/Inputs/ProductsInput.js';
import { objectToURLParams, showMessageError } from '../../../classes/functions.js';
import DatePicker, { registerLocale } from "react-datepicker";
import ptBR from 'date-fns/locale/pt-BR';
import "react-datepicker/dist/react-datepicker.css";
import InputDate from '../../../components/Inputs/Date/index.js';

registerLocale('pt-br',ptBR)

export default function Kardex(){
  const [modalKardex, setModalKardex] = useState(false);
  const [productsFrom, setProductsFrom] = useState([]);
  const [productsUntil, setProductsUntil] = useState([]);
  const [kardexMoviment, setKardexMoviment] = useState([]);

  const [showEntryKardexModal, setShowEntryKardexModal] = useState(false);
  const [typeMoviment, setTypeMoviment] = useState(0);
  const [kardexId, setKardexId] = useState(0);

  const [qtdePage, setQtdePage] = useState(50);
  const [limitPage, setLimitPage] = useState(1);
  const [page, setPage] = useState(1);
  const [carryingFilter, setCarryingFilter] = useState(false);
  const [carryingExcel, setCarryingExcel] = useState(false);

  const [searchMoviment, setSearchMoviment] = useState("Ambos");
  const [kardexModel, setKardexModel] = useState("");
  const [features, setFeatures] = useState([]);

  const [filters, setFilters] = useState({
    dataDe: '',
    dataAte: convertDate(new Date()),
    caracteristica: '',
    caracteristica_valor: '',
    produtoDe: '',
    produtoAte: ''
  });

  const [showModals, setShowModals] = useState({
    kardexType: false
  });

  const [carrying, setCarrying] = useState(true);

  const customStyles = {
    content: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      right: 'auto',
      width: '750px',
      maxHeight: '80%',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };

  useEffect(()=> {
    async function loadKardex(){
      setCarrying(false);
    }

    loadKardex();

    return () => {

    }
  }, []);

  function convertDate(time){
    if(time !== ''){
      const formatedDateAndHour = moment(time).tz('America/Sao_Paulo').format(`DD/MM/yyyy`);

      return formatedDateAndHour;
    } else{
      return '';
    }
  } 

  function getFeatures(){
    api
    .get("/api/features/getList")
    .then((response) => {
      setFeatures(response.data);
    })
    .catch((error) => {
      console.log(error?.response);
      showMessageError(error?.response?.message);
    });
  }

  function getKardex(){
    const params = {
      dataDe: filters?.dataDe,
      dataAte: filters?.dataAte,
      produtoDe: filters.produtoDe.split("-")[0].trim(),
      produtoAte: filters.produtoAte.split("-")[0].trim(),
      caracteristica: filters.caracteristica,
      caracteristica_valor: filters.caracteristica_valor,
      page: page,
      qtdePage: qtdePage,
      moviment: searchMoviment
    }

    if(kardexMoviment.length !== 0){
      setCarryingFilter(true);
    }

    api
    .get(`/api/reports/kardex?${objectToURLParams(params)}`)
    .then((response) => {
      setKardexMoviment(response.data.result);
      setCarryingFilter(false);
      setLimitPage(Math.round(response.data.total / qtdePage) + 1)
    })
    .catch((error) => {
      setCarrying(false);
      console.log(error);
      showMessageError(error.response.data);
    });
  }

  useEffect(() => {
    getFeatures();
  }, []);

  function kardex () {
    setModalKardex(true);
  }

  function closeModal () {
    setModalKardex(false);
  }

  function getExcels(){
    let param = `?dataDe=${convertDate(filters?.dataDe)}&dataAte=${convertDate(filters?.dataAte)}&produtoDe=${filters.produtoDe.split('-')[0].trim()}&produtoAte=${filters.produtoAte.split('-')[0].trim()}&mainCode=${filters.mainCode}&moviment=${searchMoviment}&modelo=${kardexModel}`;

    setCarryingExcel(true);

    api
    .get(`/api/reports/kardex/xmls${param}`)
    .then((response) => {
      setCarryingExcel(false);

      const dateAndHour = new Date();
      const formatedDateAndHour = format(dateAndHour, 'dd/MM/yyyy HH:mm:ss');

      const filename = `fluxo_de_produto ${formatedDateAndHour}.xlsx`;

      const a = document.createElement('a');
      a.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${response.data?.fileData}`;
      a.download = filename;
  
      return a.click();
    })
    .catch((error) => {
      console.log(error);
      showMessageError(error.response.data);
      setCarrying(false);
    });
  }
  
  function verifyFiltersToExcel(){
    if(filters.dataDe !== '' && filters.dataAte !== '' && searchMoviment !== ''){
      return getExcels();
    }

    return toast.error('Insira os valores dos filtros obrigatórios.');
  }

  function verifyFiltersToKardex(){
    if(filters.dataDe !== '' && filters.dataAte !== '' && searchMoviment !== ''){
      return getKardex();
    }

    return toast.error('Insira os valores dos filtros obrigatórios.');
  }

  useEffect(() => {
    getKardex();
  }, [qtdePage, page]);
  
  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />
      <Modal
        isOpen={showEntryKardexModal}
        onRequestClose={() => setShowEntryKardexModal(false)}
        style={customStyles}
        contentLabel='Entrada'
        ariaHideApp={false}
      >
        <div style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
          <h2 style={{fontWeight: '400', fontSize: '1.75rem'}}>{typeMoviment === 1 ? 'Entrada' : 'Saída'}</h2>
          <table>
            <thead>
              {typeMoviment === 1 
                ? 
                <tr>
                  <th>Data Compra</th>
                  <th>MPR</th>
                  <th>PO</th>
                  <th>RR</th>
                  <th>Main Code</th>
                  <th>Cost Center</th>
                  <th>Sub Code</th>
                </tr>
                :
                <tr>
                  <th>Solicitante</th>
                  <th>Main Code</th>
                  <th>Cost Center</th>
                  <th>Sub Code</th>
                </tr>
              }
            </thead>
            <tbody>
              <tr>
                {typeMoviment === 1 
                  ?
                    <>
                      <td>{kardexId?.DATAENTRADA}</td>
                      <td>{kardexId?.MPR}</td>
                      <td>{kardexId?.PO}</td>
                      <td>{kardexId?.RR}</td>
                      <td>{kardexId?.MAINCODE}</td>
                      <td>{kardexId?.COSTCENTER}</td>
                      <td>{kardexId?.SUBCODE}</td>
                    </>
                  :
                    <>
                      <td>{kardexId?.SOLICITANTE}</td>
                      <td>{kardexId?.MAINCODE}</td>
                      <td>{kardexId?.COSTCENTER}</td>
                      <td>{kardexId?.SUBCODE}</td>
                    </>
                  }
              </tr>
            </tbody>
          </table>
        </div>
      </Modal>
      <Modal
        isOpen={showModals.kardexType}
        onRequestClose={() => setShowModals((prevState) => ({...prevState, kardexType: false}))}
        style={customStyles}
        contentLabel='Tipo de excel'
        ariaHideApp={false}
      >
        <div style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
          <h2 style={{fontWeight: '400', fontSize: '1.75rem'}}>Qual layout você deseja para a impressão?</h2>
          <div className="formDiv">
            <select value={kardexModel} style={{height: '37.5px'}} onChange={(e) => setKardexModel(e.target.value)}>
              <option value="">Selecione</option>
              <option value={1}>Kardex</option>
              <option value={2}>Tabela</option>
            </select>
          </div>
          <div className="formDiv" style={{display: "flex", gap: "1rem"}}>
            <button style={{height: '35px'}} onClick={() => setShowModals((prevState) => ({...prevState, kardexType: false}))} className="buttonSubmit">Fechar</button>
            <button style={{backgroundColor: `${carryingExcel ? '#001fff' : ''}`, height: '35px'}} onClick={verifyFiltersToExcel} className="buttonSubmit">{carryingExcel ? "Gerando..." : "Confirmar"}</button>
          </div>
        </div>
      </Modal>
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
          <Title name="Kardex"></Title>
          <div>
            <select className='selectQtdeItens' value={qtdePage} onChange={ (e) => {setQtdePage(e.target.value);}}>
                <option value="">Itens por página</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
            </select>
          </div>
        </div>
        <div className="container">
          <div className="containerGroupData">
            <h2>Filtros</h2>
            <hr></hr>
            <div className="divGroup">
              <div className="formDiv">
                <label>Data De</label>&nbsp;<label className="required">*</label><br/>
                <InputDate filters={filters} propertyFilter={"dataDe"} setFilters={setFilters} />
              </div>
              <div className="formDiv">
                <label>Data Até</label>&nbsp;<label className="required">*</label><br/>
                <InputDate filters={filters} propertyFilter={"dataAte"} setFilters={setFilters} />
              </div>
              <ProductsInput filters={filters} setFilters={setFilters} productsFrom={productsFrom} setProductsFrom={setProductsFrom} productsUntil={productsUntil} setProductsUntil={setProductsUntil} />
              <div className="formDiv">
                <label>Característica</label>
                <select style={{height: "37.5px"}} onChange={(e) => setFilters((filter) => ({...filter, caracteristica: e.target.value}))}>
                  <option value="">Selecione</option>
                  {features.map((feature, index) => {
                    return (
                      <option value={feature.chave} key={index}>{feature.descricao}</option>
                    )
                  })}
                </select>
              </div>
              <div className="formDiv">
                <label>Valor da Característica</label><br/>
                <input type='text' placeholder='Valor da Característica' style={{height: '37.5px'}} value={filters.caracteristica_valor} onChange={(e) => setFilters((prevState) => ({
                  ...prevState,
                  caracteristica_valor: e.target.value
                }))}/>
              </div>
              <div className="formDiv">
                <label>Movimento</label>&nbsp;<label className="required">*</label><br/>
                <select style={{height: '37.5px'}} onChange={(e) => setSearchMoviment(e.target.value)}>
                  <option value="">Selecione</option>
                  <option value="Entrada">Entrada</option>
                  <option value="Saida">Saída</option>
                  <option value="Ambos">Ambos</option>
                </select>
              </div>
            </div>
            <div className="divGroup">
              <div className="formDiv" style={{display: 'flex', justifyContent: 'end', gap: '0.5rem'}}>
                <a style={{color: 'inherit'}}>
                  <button type="button" onClick={() => setShowModals((prevState) => ({...prevState, kardexType: true}))} className="buttonInsert">
                    Imprimir
                  </button>
                </a>
                <button className="buttonInsert" onClick={verifyFiltersToKardex} style={{backgroundColor: `${carryingFilter ? '#001fff' : ''}`, width: `${carryingFilter  ? '6.5rem' : ''}`}}>
                  {carryingFilter ? 'Carregando...' : 'Pesquisar'}
                </button> 
              </div>
            </div>
          </div>
          <br/>
          <div className="divGroup">
            <table>
              <thead>
                <tr>
                  <th scope="col">Cód. Prod</th>
                  <th scope="col">Descrição Prod.</th>
                  <th scope="col">Solicitante</th>
                  <th scope="col">Movimentação</th>
                  <th scope="col">Data</th>
                  <th scope="col">NF/Requisição</th>
                  <th scope="col">Quantidade</th>
                  <th scope='col'>Detalhes</th>
                </tr>
              </thead>
              <tbody>
                {kardexMoviment?.map((objectKardexMoviment) => {
                   return (
                      objectKardexMoviment?.MOVIMENTOS?.map((moviment, index) => {
                        if(moviment.MOVIMENTO === searchMoviment || searchMoviment === 'Ambos'){
                          return (
                            <tr key={index}>
                              <td data-label="Código de Produto">{objectKardexMoviment?.ID}</td>
                              <td data-label="Descrição do Produto">{objectKardexMoviment?.DESCRICAO}</td>
                              <td data-label="Soliciante">{moviment?.SOLICITANTE}</td>
                              <td data-label="Movimentação">{moviment?.MOVIMENTO}</td>
                              <td data-label="Data">{moviment?.DATAENTRADA || moviment?.DATA}</td>
                              <td data-label="Numero do Documento">{moviment?.NF || moviment?.REQUISICAO}</td>
                              <td data-label="Quantidade">{moviment?.QTDE}</td>
                              <td data-label="Detalhes">
                                <button style={{backgroundColor: 'inherit'}} onClick={() => {
                                    if(moviment?.MOVIMENTO === 'Entrada'){
                                      setTypeMoviment(1);
                                    } else{
                                      setTypeMoviment(2);
                                    }
                                    setShowEntryKardexModal(true);
                                    setKardexId(moviment)
                                  }}>
                                  <FaUser />
                                </button>
                              </td> 
                            </tr>
                          )
                        }
                      })     
                  )
                })}
                {kardexMoviment.length === 0 && <tr>
                  <td colSpan={9}><label className='required'>Nenhum registro encontrado!</label></td>
                </tr>}
              </tbody>
            </table>
          </div>
          <br />
          <div className="divGroupPagination">
            <button data-tip="Primeira página" type="button" onClick={() => setPage(1)} className="buttonFirstPage"><FaArrowLeft color="#001675" size={17} /><FaArrowLeft color="#001675" size={17} /></button>
            <button data-tip="Página anterior" type="button" onClick={() => setPage(page > 1 ? page - 1 : 1)} className="buttonPreviewPage"><FaArrowLeft color="#001675" size={17} /></button>
            <div className="divLabelPagination">
              <center><label className="labelPage">Exibindo página {page} de {limitPage}</label></center>
            </div>
            <button data-tip="Próxima página" type="button" onClick={() => setPage((page + 1) < limitPage ? page + 1 : limitPage)} className="buttonNextPage"><FaArrowRight color="#001675" size={17} /></button>
            <button data-tip="Última página" type="button" onClick={() => setPage(limitPage)} className="buttonLastPage"><FaArrowRight color="#001675" size={17} /><FaArrowRight color="#001675" size={17} /></button>
          </div>
        </div>
      </div>}

      <Modal  
        isOpen={modalKardex}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Kardex"
        ariaHideApp={false}
      >
        <div className="body-modal">
          <div className="formDiv">
            <div className="divGroup">
              
            </div>
          </div>
          <div className="formDiv">
            <button type="button" className="buttonSubmit" onClick={kardex}>Imprimir</button>
            <button type="button" className="buttonCancel" onClick={closeModal}>Fechar</button>
          </div>
        </div>
      </Modal>
    </div>
  )
}